/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { RegeneratorD } from "./modelRegeneratorD";

class ControllerRegeneratorD extends ControllerModel {
  constructor() {
    super("ControllerRegeneratorD");
    
    this.setNewNode = (callback) => {
      let _regeneratorD = new RegeneratorD();
      _regeneratorD.decorate(callback);

      this.addNode(_regeneratorD);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let _regeneratorD = new RegeneratorD();
      _regeneratorD.copyFrom(node);
      _regeneratorD.decorate(callback);
      this.addNode(_regeneratorD)
    }

    this.getProperties = async (node) => {
      let n = new RegeneratorD();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new RegeneratorD();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerRegeneratorD };
